import { FaTelegramPlane, FaVk } from 'react-icons/fa';
import type { ApiChatChannelTypeSimpleModel } from '@/core/generated/api';
import maxIcon from '../assets/max-logo.png';
import voxIcon from '../assets/vox-care.webp';
import classes from './ChatChannelIcon.module.scss';

/** Обозначает канал переписки */
export const ChatChannelIcon = ({ channel }: { channel?: ApiChatChannelTypeSimpleModel }) => (
    <span
        className={classes.icon}
        title={channel?.name || 'Канал неизвестен'}
        role="img"
        aria-label={channel?.name || 'Канал неизвестен'}
    >
        {channel?.id === 'vox'
            ? <img
                src={voxIcon}
                alt=""
            />
            : channel?.id === 'telegram'
                ? <FaTelegramPlane color="#24a1de" />
                : channel?.id === 'vk'
                    ? <FaVk color="#0077ff" />
                    : channel?.id === 'max'
                        ? <img
                            src={maxIcon}
                            alt=""
                        />
                        : <span className={classes.badge}>{channel?.id === 'avito'
                            ? 'A'
                            : '?'}</span>}
    </span>
);
